
  import { css } from 'lit';
  export const styles = css`:host([variant=danger]) [part~=base]{color:var(--ig-error-100-contrast)}`;
  